import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import { AppPermission, AppRole } from '../types';

interface CanProps {
  permission?: AppPermission;
  role?: AppRole;
  anyOf?: AppPermission[];
  allOf?: AppPermission[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Component that renders its children only if the current user meets
 * the specified authorization criteria.
 */
export function Can({ permission, role, anyOf, allOf, children, fallback = null }: CanProps) {
  const { hasPermission, hasRole, hasAnyPermission, hasAllPermissions } = usePermissions();

  let authorized = true;

  if (permission && !hasPermission(permission)) {
    authorized = false;
  }
  
  if (role && !hasRole(role)) {
    authorized = false;
  }
  
  if (anyOf && !hasAnyPermission(anyOf)) {
    authorized = false;
  }
  
  if (allOf && !hasAllPermissions(allOf)) {
    authorized = false;
  }

  return authorized ? <>{children}</> : <>{fallback}</>;
}
